/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Removed_Members_NoteInputs */



/**
* | output |
* | --- |
* | "Removed members lose access the next time they sync." |
*
* @param {Team_Share_Removed_Members_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_removed_members_note = /** @type {((inputs?: Team_Share_Removed_Members_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Removed_Members_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Removed members lose access the next time they sync.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Removed members lose access the next time they sync.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Removed members lose access the next time they sync.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Removed members lose access the next time they sync.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Removed members lose access the next time they sync.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Removed members lose access the next time they sync.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Removed members lose access the next time they sync.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Removed members lose access the next time they sync.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Removed members lose access the next time they sync.")
	return /** @type {LocalizedString} */ ("Removed members lose access the next time they sync.")
});